<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="items"
        item-key="id"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        class="elevation-1 items-table"
        :footer-props="{
        'items-per-page-options': [20, 100, 1000],
        'items-per-page-text': 'Položek na stránku'
      }"
        :header-props="{
          'sort-by-text': 'Seřadit podle...'
        }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
              v-model="search"
              label="Hledat..."
              debounce="5000"
              hide-details
          ></v-text-field>
          <month-picker v-model="monthFilter" />
          <v-checkbox
              v-model="validnow"
              label="Dnešní"
              hide-details
          ></v-checkbox>
          <v-spacer></v-spacer>
          <item-form :id="editedId" @updated="loadDataFromServer" @closed="editedId = '0'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  :v-if="isAdmin"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="add-button"
              >
                <v-icon class="mr-2">mdi-plus</v-icon>
                Přidat
              </v-btn>
            </template>
          </item-form>
          <confirm-dialog message="Opravdu odstranit zábor?" :action="confirmAction" />
        </v-toolbar>
      </template>
      <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
        {{ pageStart }}-{{ pageStop }} ze {{ itemsLength }}
      </template>
      <template v-slot:item.validfrom="{ item }">
        <span>{{ new Date(item.validfrom).toLocaleDateString('cs-cz').replace(/ /g,'') }}</span> - <span>{{ new Date(item.validto).toLocaleDateString('cs-cz').replace(/ /g,'') }}</span>
      </template>
      <template v-slot:item.finding="{ item }">
        <v-chip v-if="item.finding" color="green" text-color="white" link :href="downloadUrl(item.id, 'finding')">
          Zjištění
        </v-chip>
        <v-chip v-else color="red" text-color="white">
          - - -
        </v-chip>
      </template>
      <template v-slot:item.request="{ item }">
        <v-chip v-if="item.request" color="green" text-color="white" link :href="downloadUrl(item.id, 'request')">
          Žád.
        </v-chip>
        <v-chip v-else color="red" text-color="white">
          - - -
        </v-chip>
      </template>
      <template v-slot:item.stand="{ item }">
        <v-chip v-if="item.stand" color="green" text-color="white" link :href="downloadUrl(item.id, 'stand')">
          MPO
        </v-chip>
        <v-chip v-else color="red" text-color="white">
          - - -
        </v-chip>
      </template>
      <template v-slot:item.decision="{ item }">
        <v-chip v-if="item.decision" color="green" text-color="white" link :href="downloadUrl(item.id, 'decision')">
          DPO
        </v-chip>
        <v-chip v-else color="red" text-color="white">
          - - -
        </v-chip>
      </template>
      <template v-slot:item.paid="{ item }">
        <span>
          <v-chip v-if="item.paid === 'paid'" color="green" text-color="white">Zapl.</v-chip>
          <v-chip v-if="item.paid === 'notpaid'" color="red" text-color="white">Nezap.</v-chip>
          <v-chip v-if="item.paid === 'notrequired'" color="green" text-color="white">Bez p.</v-chip>
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            v-if="isAdmin"
            small
            class="mr-2"
            @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
            v-if="isAdmin"
            small
            @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {api, defaultApiErrorHandler} from '@/main';
import ItemForm from "@/components/ItemForm";
import ConfirmDialog from "@/components/ConfirmDialog";
import MonthPicker from "@/components/MonthPicker";
import {mapGetters} from "vuex";

export default {
  name: 'ItemsTable',
  components: {MonthPicker, ItemForm, ConfirmDialog},

  data () {
    return {
      total: 0,
      items: [],
      search: "",
      monthFilter: "",
      validnow: true,
      loading: true,
      options: {},
      editedId: "",
      confirmAction: null,
      headers: [
        {
          text: 'Adresa',
          value: 'address',
          sortable: true,
          class: 'first-td',
        },
        {
          text: 'Popis',
          value: 'description',
          sortable: true,
        },
        {
          text: 'Žadatel',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Platnost',
          value: 'validfrom',
          sortable: true,
        },
        {
          text: 'Zjištění MP',
          value: 'finding',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Žádost',
          value: 'request',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Stanovisko MPO',
          value: 'stand',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Rozhodnutí DPO',
          value: 'decision',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Poplatek',
          value: 'paid',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Akce',
          value: 'actions',
          sortable: false
        },
      ],
    }
  },

  watch: {
    options: {
      handler () {
        this.loadDataFromServer()
      },
      deep: true,
    },
    search() {
      this.options.page = 1;
      this.loadDataFromServer();
    },
    monthFilter(val) {
      if (val) {
        this.validnow = false;
      }
      this.options.page = 1;
      this.loadDataFromServer();
    },
    validnow(val) {
      if (val) {
        this.monthFilter = '';
      }
      this.options.page = 1;
      this.loadDataFromServer();
    },
  },

  computed: {
    ...mapGetters(["isAdmin"])
  },

  methods: {
    loadDataFromServer () {
      this.loading = true;

      const params = {
        search: this.search,
        month: this.monthFilter,
        validnow: this.validnow ? true : undefined,
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        sortBy: this.options.sortBy[0],
        sortDesc: this.options.sortDesc[0],
      };
      api
          .get('item.php', { params: params })
          .then(response => {
            console.log('response', response);
            this.items = response.data.items;
            this.total = response.data.total;
            this.loading = false;
          })
          .catch(defaultApiErrorHandler);
    },

    editItem (item) {
      this.editedId = item.id;
    },
    deleteItem (item) {
      let _this = this;
      this.confirmAction = function () {
        api
            .delete('item.php?id=' + item.id)
            .then(response => {
              console.log('response', response);
              _this.loadDataFromServer();
            })
            .catch(defaultApiErrorHandler);
      }
    },
    downloadUrl (id, field) {
      return api.defaults.baseURL + 'download.php?id=' + id + '&field=' + field;
    },
  },
}
</script>

<style>
.items-table .v-chip {
  width: 100%;
  max-width: 8em;
  text-align: center;
  display: inline-block;
}
.items-table .v-data-table__mobile-row__cell .v-chip {
  width: 12em;
}
.items-table .add-button {
  margin-left: 1em;
}
.items-table td {
  padding: 0 1px !important;
}
.items-table td {
  padding-left: 0.8em !important;
}
</style>
